<template>
  <v-container>
    <v-breadcrumbs :items="itemsForNavigation" style="padding: 5px 0px;"></v-breadcrumbs>

    <v-row>
      <v-col md="6" offset-md="3">
        <v-card>
          <v-card-text class="px-8 py-6">
            <v-alert dense text type="info" class="caption mb-6">
              {{ t('Info') }}
            </v-alert>

            <v-text-field
              v-model="callbackUrl"
              :label="t('Callback URL')"
              :error-messages="fieldErrors.callbackUrl"
              outlined
              dense
              hide-details="auto"
              class="mb-6"
              @input="fieldErrors.callbackUrl = []"
            ></v-text-field>

            <v-text-field
              v-model="uniqueIds"
              :label="t('Device ids')"
              :hint="t('Device ids hint')"
              :error-messages="fieldErrors.uniqueIds"
              persistent-hint
              outlined
              dense
              class="mb-6"
              @input="fieldErrors.uniqueIds = []"
            ></v-text-field>

            <v-row v-for="type in types" :key="type" align="center" no-gutters class="mb-2">
              <v-col cols="12" sm="5" class="font-weight-medium">{{ t(type) }}</v-col>
              <v-col cols="12" sm="7" class="text-sm-right">
                <v-btn
                  small
                  color="primary"
                  class="mr-2"
                  :loading="loading === type + 'subscribe'"
                  :disabled="!!loading"
                  @click="send(type, true)"
                >
                  {{ t('Subscribe') }}
                </v-btn>
                <v-btn
                  small
                  outlined
                  color="primary"
                  :loading="loading === type + 'unsubscribe'"
                  :disabled="!!loading"
                  @click="send(type, false)"
                >
                  {{ t('Unsubscribe') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import httpClient from '@/api/httpClient'
import store from '@/store/store'
import translate from '@/utils/genTable/multilanguageHelper.js'

export default {
  name: 'StreamaxWebhooksPage',
  data() {
    return {
      types: ['GPS', 'ALARM'],
      callbackUrl: `${process.env.VUE_APP_BACKEND_URL.replace(/\/?$/, '/')}streamax/webhook`,
      uniqueIds: '',
      loading: null,
      fieldErrors: { callbackUrl: [], uniqueIds: [] },
      itemsForNavigation: [
        {
          text: this.$t('navigation.video.Video'),
          disabled: true
        },
        {
          text: this.$t('navigation.video.Streamax Webhooks'),
          disabled: true
        }
      ]
    }
  },
  methods: {
    t(key) {
      return translate(key, 'pages.streamaxWebhooks')
    },
    notify(type, message) {
      store.dispatch('notification/add', { type, message }, { root: true })
    },
    // Shows validation errors under their field; returns the ones that have no field here.
    showFieldErrors(errors) {
      const unmatched = []
      for (const error of errors) {
        const name = error.PropertyName.split('.').pop()
        const key = name.charAt(0).toLowerCase() + name.slice(1)
        if (key in this.fieldErrors) {
          this.fieldErrors[key] = [...this.fieldErrors[key], error.Error]
        } else {
          unmatched.push(error.Error)
        }
      }
      return unmatched
    },
    async send(type, subscribe) {
      this.loading = type + (subscribe ? 'subscribe' : 'unsubscribe')
      this.fieldErrors = { callbackUrl: [], uniqueIds: [] }

      try {
        await httpClient.post('streamax/webhook-subscription', {
          type,
          subscribe,
          callbackUrl: this.callbackUrl,
          uniqueIds: this.uniqueIds
        })
        this.notify('success', this.t(subscribe ? 'Subscribed' : 'Unsubscribed'))
      } catch (e) {
        const data = e.response && e.response.data

        if (data && data.errors) {
          const unmatched = this.showFieldErrors(data.errors)
          if (unmatched.length) {
            this.notify('error', unmatched.join(' '))
          }
        } else {
          this.notify('error', (data && data.Message) || this.t('Request failed'))
        }
      } finally {
        this.loading = null
      }
    }
  }
}
</script>
